module.exports = "/images/vendor/flag-icon-css/flags/1x1/at.svg?5ab33f744e92b143361e951c81f0f60d";